<template>
    <b-form-group :label="label" :invalid-feedback="errorTxt" :state="state">
        <div v-if="placeholder" class="alert alert-info">{{placeholder}}</div>
        <div v-if="$scopedSlots.before">
          <slot name="before" />
        </div>
        <editor v-model="inputVal" api-key="0kdgx2lvpdmk15c5ys9wqnzql5k7umb7jk2c9l7pww3vdjbt" :init="config"></editor>
    </b-form-group>
</template>

<script>
    import Editor from '@tinymce/tinymce-vue';

    export default {
        components: {
            'editor': Editor
        },
        props: {
            model: Object,
            attribute: String,
            label: String,
            errors: Array,
            placeholder: String,
            maxLength: {type: Number, default: 20000},
            errorOnly: Boolean,
            height: {type: Number, default: 500}
        },
        data() {
            return {
                inputVal: this.model[this.attribute] ? this.model[this.attribute] : null,
                state: null,
                errorTxt: '',
                config: {height: this.height, plugins: ['lists', 'image', 'table']}
            }
        },
        watch: {
            model: {
                handler(val) {
                    this.state = null;
                    this.errorTxt = '';
                    this.inputVal = val[this.attribute];
                }, deep: true
            },
            inputVal(val) {
                this.state = null;
                this.errorTxt = '';
                this.model[this.attribute] = val;
            },
            errors(val) {
                let hasErr = false;
                if (val.length) {
                    val.forEach(v => {
                        if (v.param === this.attribute) {
                            this.state = false;
                            this.errorTxt = v.msg;
                            hasErr = true;
                        }
                    });
                }
                if (!this.errorOnly) {
                    this.state = !hasErr;
                }
            }
        },
        methods: {},
    }
</script>